// eslint-disable-next-line
__webpack_public_path__ =
  process.env.NODE_ENV === 'production'
    ? window.location.pathname.substring(
      0,
      window.location.pathname.indexOf('index.html')
    )
    : '/'
